import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const addNotificationSuccess = (err) => {
    notification.success({
        message: err,
    });
};

const state = () => ({
    order: {
        type: 'LETTEROFCONTENT',
        relation: {type: 'CONSUMER'},
        relationID: null,
        signatureType: 'ESIGNATURE',
        signatureData: null,
        productID: null,
        key: 0,
        flowQuestions: [],
        extraData: {
            notes: '',
        },
    },
    loadingCreateOrder: false,
    errorCreateOrder: false,
    loadingPreFillRelationOnOrder: false,
    errorPreFillRelationOnOrder: false,
    loadingFetchLetterOfContentFlowQuestions: false,
    errorFetchLetterOfContentFlowQuestions: false,
});

const actions = {
    async resetLetterOfContentOrder({commit}) {
        await commit('resetLetterOfContentOrder');
    },

    async preFillRelationOnENERGYOrder({commit}, data) {
        try {
            await commit('preFillRelationOnLetterOfContentOrderBegin');
            await commit('addRelationToLetterOfContentOrder', data.value);
            await commit('preFillRelationData', data.value);
            await commit('preFillRelationOnLetterOfContentOrderSuccess');
            await data.stepRoute();
        } catch (err) {
            await commit('preFillRelationOnLetterOfContentOrderErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async addRelationToENERGYOrder({commit}, data) {
        await commit('addRelationToLetterOfContentOrder', data.value);
        await data.stepRoute();
    },

    async createENERGYOrder({commit, state}, data) {
        try {
            await commit('createLetterOfContentOrderBegin');
            const orderToSubmit = data.orderData || state.order;
            const response = await DataService.post('/orders', orderToSubmit);
            await commit('createLetterOfContentOrderSuccess', response.data);
            await data.successRoute();
            addNotificationSuccess('Letter of Content aanvraag is succesvol aangemaakt.');
        } catch (err) {
            await commit('createLetterOfContentOrderErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },

    async resetENERGYOrder({commit}) {
        await commit('resetLetterOfContentOrder');
    },

    async setSignatureLetterOfContentData({commit}, data) {
        await commit('setSignatureLetterOfContentData', data);
    },

    async fetchLetterOfContentFlowQuestions({commit}, data) {
        console.log('fetchLetterOfContentFlowQuestions called with data:', data);
        try {
            await commit('fetchLetterOfContentFlowQuestionsBegin');
            console.log('Making API call to offerflow/shop/flowquestions');
            const response = await DataService.get('offerflow/shop/flowquestions', data);
            console.log('API response:', response.data);
            await commit('fetchLetterOfContentFlowQuestionsSuccess', response.data);
        } catch (err) {
            console.error('Error fetching flow questions:', err);
            await commit('fetchLetterOfContentFlowQuestionsErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
